// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.


/**
 *
 */
function disableAddToCartButton() {
    const addToCartButtons = document.querySelectorAll("[data-add-to-cart]");
    for (let i = 0; i < addToCartButtons.length; i++) {
        addToCartButtons[i].setAttribute("disabled", "disabled");
    }
}

function enableAddToCartButton() {
    const addToCartButtons = document.querySelectorAll("[data-add-to-cart]");
    for (let i = 0; i < addToCartButtons.length; i++) {
        addToCartButtons[i].removeAttribute("disabled")
    }
}

function disableShopifyPaymentButton() {
    const shopifyPaymentButton = document.querySelector(".shopify-payment-button__button");
    if (shopifyPaymentButton) {
        shopifyPaymentButton.setAttribute("disabled", "disabled");
    }
}

function enableShopifyPaymentButton() {
    const shopifyPaymentButton = document.querySelector(".shopify-payment-button__button");
    if (shopifyPaymentButton) {
        shopifyPaymentButton.removeAttribute("disabled");
    }
}

(function () {

    const addToCartButton = document.querySelector("[data-add-to-cart]");
    const ringSizeSelect = document.querySelector("[name='options[Ring Size]'],[name='options[Ring size]'],[name='options[size]'],[name='options[Size]']");

    if (addToCartButton && ringSizeSelect) {

        if (ringSizeSelect.value == '' || ringSizeSelect.value == '-- Select Ring Size --' || !ringSizeSelect.value) {
            disableAddToCartButton();
            disableShopifyPaymentButton();
        } else {
            enableAddToCartButton();
            enableShopifyPaymentButton();
        }
    }
})();


document.addEventListener("cart:item-added", function (evt) {
    console.log("Item added to the cart");
    console.log(evt.detail.product);
});


// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
    console.log("Item added to the cart");
    console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
    console.log("Cart updated");
    console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
    console.log("Cart error");
    console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
    console.log("Quick cart opened");
    console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
    console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
    console.log("Product variant changed");

    // Reapply additional options to newly selected variant
    BOLD.options.app.optionProducts[0].priceHandler.updateTotalElement(true)

    const addToCartButton = document.querySelector("[data-add-to-cart]");
    const shopifyPaymentButton = document.querySelector(".shopify-payment-button");
    const ringSizeSelect = document.querySelector("[name='options[Ring Size]'],[name='options[Ring size]'],[name='options[size]'],[name='options[Size]']")
    const product = JSON.parse(document.querySelector('[id^="ProductJson-"]').innerText);
    const productLabelWrapper = ringSizeSelect.parentNode.parentNode.querySelector(".product__label-wrapper");

    if (addToCartButton && ringSizeSelect) {

        // get selected option and check if it should be ignored (this refferst to variant entries added by the client. Instead of notmal product variants
        // they added text "Select a ring size" or similar.)
        let selectedOption = ringSizeSelect.selectedOptions[0];

        /* if(selectedOption.dataset.skipVariant){
             return;
         }*/

        if (selectedOption.dataset.skipVariant) {
            disableAddToCartButton();
            disableShopifyPaymentButton();
            ringSizeSelect.classList.add("required");

            // requried label
            let reqLabel = productLabelWrapper.querySelector(".required");

            if (!reqLabel) {
                let e = document.createElement("span");
                e.classList.add("required");
                e.innerHTML = "Please select a size.";
                productLabelWrapper.append(e);
            }
        } else {
            enableAddToCartButton();
            enableShopifyPaymentButton();
            ringSizeSelect.classList.remove("required");
            if (productLabelWrapper.querySelector(".required")) {
                productLabelWrapper.querySelector(".required").remove();
            }
        }
    }
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
    console.log("Product quantity updated");
    console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
    console.log("Quickview loaded");
});


/* Wishlist app */


/**
 * Prevent wishlist button to add products to the cart if user declined cookies
 */

(function () {

    const STOREFRONT_DOMAIN = 'alisonmoore.co.uk';
    const CHECKOUT_DOMAIN = 'alisonmoore.co.uk';
    const SF_API_TOKEN = '01e750a07297c51ee8eae47eebbc3cbb';

    const cookiesLink = document.querySelector(".footer__credits .header__links-list > li:nth-child(2)");
    cookiesLink.addEventListener("click", function (e) {
        e.preventDefault();

        // re-show the preferences modal
        privacyBanner.showPreferences({
            storefrontAccessToken: SF_API_TOKEN,
            checkoutRootDomain: CHECKOUT_DOMAIN,
            storefrontRootDomain: STOREFRONT_DOMAIN,
            // Optional
        }).then(() => {
            console.log('preferences modal opened');
        });
    });


    /**
     *
     * @return {string}
     */
    function modalContent() {

        const m = "<div class='modal-inner'>" +
            "<div class='modal-header'>Notice</div>" +
            "<div class='modal-content'>" +
            "<p>The wishlist feature requires additional permissions in order to work properly. Please press \"<strong>Accept</strong>\" button to extend your cookie consent.</p>" +
            "</div>" +
            "<div class='modal-footer'>" +
            "<button type='button' name='cancel' class='btn-no-modal btn--x-small btn btn--overlay btn--secondary'><span>Cancel</span></button>" +
            "<button type='button' name='cancel' class='btn-yes-modal btn--x-small btn btn--overlay btn--primary'><span>Accept</span></button>" +
            "</div>" +
            "</div>";

        return m;
    }

    /**
     *
     */
    function createModal() {

        const modal_overlay = document.createElement("div");
        modal_overlay.classList.add("modal-cookie-overlay");
        modal_overlay.classList.add("modal");
        modal_overlay.innerHTML = modalContent();
        document.body.append(modal_overlay);
    }

    /**
     *
     */
    function removeModal() {
        document.querySelector(".modal-cookie-overlay").remove();
    }

    /**
     *
     */
    function updateCookieConsentPerms() {

        window.Shopify.customerPrivacy.setTrackingConsent(
            {
                "preferences": true,
                "checkoutRootDomain": CHECKOUT_DOMAIN,
                "storefrontRootDomain": STOREFRONT_DOMAIN,
                "storefrontAccessToken": SF_API_TOKEN
            },
            () => {
            }
        );
    }

    /**
     *
     */
    function checkCookiePermissions() {

        /* Open a modal box if requirement are not met and ask user too allow additional cookies. */

        if (!window.Shopify.customerPrivacy.preferencesProcessingAllowed()) {

            createModal();

            // Bind events

            const listenOnce = (el, evt, fn) => el.addEventListener(evt, fn, {once: true});

            listenOnce(
                document.querySelector('.btn-no-modal'),
                'click',
                () => {
                    removeModal();
                }
            ); // 'Hello!' will only be logged on the first click

            listenOnce(
                document.querySelector('.btn-yes-modal'),
                'click',
                () => {
                    updateCookieConsentPerms();
                    removeModal();
                }
            ); // 'Hello!' will only be logged on the first click
        }
    }


    // If wishlist app does not have cookie consent it will add product to the cart instead of to a wishlist at the single product template.
    // We want to prevent this.
    const addToWishlistButton = document.querySelector(".swym-add-to-wishlist");
    const addToWishlistViewButtons = document.querySelectorAll(".swym-add-to-wishlist-view-product");

    // Heart icon on the header
    const wishlistButton = document.querySelectorAll(".swym-wishlist");

    for (let i = 0; i < wishlistButton.length; i++) {
        wishlistButton[i].addEventListener("click", checkCookiePermissions);
    }

    if(addToWishlistViewButtons.length > 0) {
        for (let i = 0; i < addToWishlistViewButtons.length; i++) {
            addToWishlistViewButtons[i].addEventListener("click", function (e) {
                if (!window.Shopify.customerPrivacy.preferencesProcessingAllowed()) {
                    e.preventDefault();
                    e.stopPropagation();
                    checkCookiePermissions();
                }
            });
        }
    }

    if (addToWishlistButton) {

        addToWishlistButton.addEventListener("click", function (e) {
            if (!window.Shopify.customerPrivacy.preferencesProcessingAllowed()) {
                e.preventDefault();
                e.stopPropagation();
                checkCookiePermissions();
            }
        });


        //Executed after SWYM has loaded all necessary resources.
        function onSwymLoadCallback(swat) {

            swat.evtLayer.addEventListener("sw:removedfromwishlist", function (e) {
                var data = e.detail.d;
                var activeProductId = SwymPageData.empi,
                    activeVariantId = SwymPageData.epi;

                if (addToWishlistButton && activeProductId == data.empi && activeVariantId == data.epi) {
                    // Removed -> update button label
                    addToWishlistButton.querySelector("span:last-child").innerHTML = "Add to Wishlist";
                    addToWishlistButton.removeAttribute("disabled");
                }
            });

            swat.evtLayer.addEventListener("sw:addedtowishlist", function (e) {
                var data = e.detail.d;

                var activeProductId = SwymPageData.empi,
                    activeVariantId = SwymPageData.epi;

                if (addToWishlistButton && activeProductId == data.empi && activeVariantId == data.epi) {
                    // Added -> update button label
                    addToWishlistButton.querySelector("span:last-child").innerHTML = "Saved";
                    addToWishlistButton.setAttribute("disabled", true);
                }
            });

            function fetchCallbackFn(products) {
                var activeProductId = SwymPageData.empi,
                    activeVariantId = SwymPageData.epi;
                var isInWishlist = products.find(function (p) {
                    return p.empi == activeProductId && p.epi == activeVariantId;
                });

                if(addToWishlistButton){
                    if (isInWishlist) {
                        addToWishlistButton.setAttribute("disabled", true);
                        addToWishlistButton.querySelector("span:last-child").innerHTML = "Saved";
                    } else {
                        addToWishlistButton.removeAttribute("disabled");
                    }
                }
            }

            if (addToWishlistButton) {
                swat.fetchWrtEventTypeET(fetchCallbackFn, 4);
            }
        }

        if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
        }
        window.SwymCallbacks.push(onSwymLoadCallback);
    }
})();


/* BOLD Options APP customization */

/*BOLD.options.app.on('option_products_loaded', function (data) {
    console.log("BOLD Event: option_products_loaded");
});
BOLD.options.app.on('total_changed', function (data) {
    console.log("BOLD Event: total_changed");
});
BOLD.options.app.on('price_updated', function (data) {
    console.log("BOLD Event: price_updated");
});
BOLD.options.app.on('option_created', function (data) {
    console.log("BOLD Event: option_created");
});
BOLD.options.app.on('refresh', function (data) {
    console.log("BOLD Event: refresh");
});
BOLD.options.app.on('BOLD_COMMON_variant_changed', function (data) {
    console.log("BOLD Event: BOLD_COMMON_variant_changed");
});
BOLD.options.app.on('BOLD_COMMON_variant_changed', function (data) {
    console.log("BOLD Event: BOLD_COMMON_variant_changed");
});
BOLD.options.app.on('option_changed', function (data) {
    console.log("BOLD Event: option_changed");
});*/


/**
 * option_products_loaded BOLD.options.app.on('option_products_loaded', function (data) {
 * cart_prices_updated    BOLD.options.app.on('cart_prices_updated', function (data) {
 * total_changed          BOLD.options.app.on('total_changed', function (data) {
 * price_updated          BOLD.options.app.on('price_updated', function (data) {
 * option_created         BOLD.options.app.on('option_created', function (data) {
 *
 * no_option_products_loaded
 * dom_loaded
 * refresh_options_dropdown
 * refresh_options_dropdownmulti
 * "template_changed_" + T
 * cart_fixed
 * refresh
 * BOLD_COMMON_variant_changed
 * settings_loaded
 * checkout_cloned
 * checking_out
 * variants_swapped
 * "variant_swap_" +t.discounts[e].variant_id
 * edit_in_cart_opened
 * edit_in_cart_closed
 * edit_in_cart_loaded
 * line_item_updated
 * adding_to_cart
 * unhandledRejection
 * rejectionHandled
 * preselections_loaded
 * priced_option_quantity_changed
 * adding_priced_options
 * options_loaded
 * no_options_loaded
 */